interface Query {
  [key: string]: string;
}
export const generateQuery = (object: Query) => {
  const result = '?' + new URLSearchParams(object).toString();
  return result;
};
